import React, { FC } from "react";
import { Button, ButtonProps } from "@UI/Components/Button/Button";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "./messages";
import { Icon } from "@UI/Components/Icon/Icon";
import { ArrowLeft } from "@UI/Components/Icons/ArrowLeft";

export const BackLink: FC<
  ButtonProps & { noArrow?: boolean; text?: React.ReactNode }
> = ({ noArrow, text, ...props }) => {
  return (
    <Button variant="link" colorScheme="pink" paddingX="0" {...props}>
      {noArrow !== true && <Icon as={ArrowLeft} marginRight="2" />}
      {text ? text : <FormattedMessage {...messages.goBack} />}
    </Button>
  );
};
